export enum LeadsType {
    New = 'false',
    Archived = 'true',
}
